import { StateCreator } from 'zustand';
import { StoreInterface } from '@/stores/store';
import { Channel } from '@/typings/backend';
import { mergeArraysById } from '@/utils/mergeObjects';

export type ChannelSlice = {
  websocketChannels: Channel[];
  mergeChannels: (channels: Channel[]) => void;
  removeWebsocketChannel: (channelId: string) => void;
};

export const createChannelSlice: StateCreator<StoreInterface, [], [], ChannelSlice> = (set) => ({
  websocketChannels: [],

  mergeChannels: (websocketChannels) =>
    set((state) => {
      const currentChannels = state.websocketChannels || [];

      return {
        websocketChannels: mergeArraysById(currentChannels, websocketChannels, 'id'),
      };
    }),

  removeWebsocketChannel: (channelId) =>
    set((state) => ({
      websocketChannels: state.websocketChannels.filter((c) => c.id !== channelId),
    })),
});
